import React from 'react';
import './ButtonSpinner.css';

const Spinner = ({ loadingInfo = "Loading...", size = 40, color = "#004aad", backgroundColor = "#d0d0d0", textColor }) => {
    return (
        <div className="button-spinner-overlay">
            <div className="button-spinner-container">
                <div className="button-spinner-circle" style={{ width: `${size}px`, height: `${size}px`, border: `2px solid ${backgroundColor}`, borderTopColor: color }} />
                <div className="button-spinner-text" style={{ color: `${textColor}` }}>{loadingInfo}</div>
            </div>
        </div>
    );
};

export default Spinner;